import { useTranslation } from 'react-i18next';
import ControlledNumericField from 'components/shared/ControlledFields/ControlledNumericField';
import { Box } from '@mui/material';
import InputAdornment from '@mui/material/InputAdornment';
import MultiStepForm from 'components/shared/MultiStepForm/MultiStepForm';

export const BaseProfileForm = () => {
  const { t } = useTranslation('common');

  return (
    <Box
      sx={{
        '& section': { pt: 4 },
        '& .MuiBox-root': { maxWidth: '100%', textWrap: 'balance' }
      }}
    >
      <MultiStepForm.Section title={t('baseProfile.title')}>
        <ControlledNumericField
          name="neg_hours_base"
          label={t('baseProfile.negHoursBase')}
          InputProps={{
            endAdornment: (
              <InputAdornment position="start">
                {t('baseProfile.hours')}
              </InputAdornment>
            )
          }}
        />
        <ControlledNumericField
          name="neg_hours_factor"
          label={t('baseProfile.negHoursFactor')}
          InputProps={{
            endAdornment: (
              <InputAdornment position="start">
                {t('baseProfile.percent')}
              </InputAdornment>
            )
          }}
        />
        <ControlledNumericField
          name="neg_hours_min_time_block"
          label={t('baseProfile.negHoursMinTimeBlock')}
          InputProps={{
            endAdornment: (
              <InputAdornment position="start">
                {t('baseProfile.hours')}
              </InputAdornment>
            )
          }}
        />
      </MultiStepForm.Section>
    </Box>
  );
};
